module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"report_button":"举报及阻"}}')
  delete Component.options._Ctor
}
